// extracted by mini-css-extract-plugin
module.exports =  {"tableAction":"tableAction__ICkOt","tips":"tips__9JG6r"};